import * as Yup from 'yup';

export const newViolationSchema = Yup.object().shape({
  passport: Yup.object().shape({
    id: Yup.mixed().nullable(true).required("Identitas Diri harus diisi"),
  }),
  date: Yup.object().shape({
    start: Yup.mixed().required("Tanggal Kejadian harus diisi").nullable(true),
    end: Yup.mixed().required("Tanggal berlaku pelanggaran harus diisi").nullable(true),
  }),
  level: Yup.mixed().oneOf([0, 1, 2, 3],"Anda harus memilih jenis pelanggaran dengan benar").required("Jenis Pelanggaran harus diisi").nullable(true),
});